import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ThemeService from 'themes/ThemeService';
import { translate } from 'services/i18nService';

import styles from './ChatNotificationsTypes.css';


function CampaignNotification({ showBuyTokensModal }) {
  const theme = ThemeService.theme.chatOffer;

  if (!theme) {
    return null;
  }

  return (
    <div
      className={classNames(styles.campaignNotification, theme.wrapperClass)}
      onClick={showBuyTokensModal}
    >
      <div className={styles.tint} />
      <div className={styles.content}>
        {Boolean(theme.title) && (
          <h5 className={classNames(styles.campaignTitle, theme.titleClass)}>
            {theme.title}
          </h5>
        )}
        {Boolean(theme.text) && (
          <p className={styles.campaignText}>
            {theme.text}
          </p>
        )}
        <button className={styles.buyButton}>
          {translate('advertising.buy.tokens.btn')}
        </button>
      </div>
    </div>
  );
}

CampaignNotification.propTypes = { showBuyTokensModal: PropTypes.func.isRequired };

export default CampaignNotification;
